import { React, useEffect, useRef, useState } from "react";
import Block from "./Block/Block";
import { useDispatch, useSelector } from "react-redux";
import "./Preview.css";
import { updateCurrentBlockState } from "../../../Redux/actions/projectActions";
import "../../../assets/styles/FontsStyle.css";
// import watermarkimg from "../../../assets/icons/Scrollx_Black.png"
import scrollxLogo from "../../../assets/icons/Brand_Logos/ScrollX_LOGO_White_new.png";

const blockInsetClass = {
  default: "float-none w-[100%] ",
  left: "mr-[50%] w-[50%] float-left",
  right: "ml-[50%] w-[50%] float-right",
};
const focusDiv = (idx, currentIdx) => {
  if (idx === currentIdx) {
    return "focusDiv";
  } else {
    return "";
  }
};

const getWindowSize = () => {
  return {
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  };
};

const detectwindowSize = () => {
  const { winWidth, winHeight } = getWindowSize();
  console.log("detectwindowSize =>", winWidth);
  return winHeight;
};

const scrollTo = (parent, child, slct, size) => {
  let parent1 = document.getElementById(parent);
  let child1 = document.getElementById(child);

    if (child1 && parent1) {
  // const navbar = document.getElementById("navbar_1");
  // const navbarHeight = navbar ? navbar.offsetHeight : 0;

  const childRect = child1.getBoundingClientRect();
  const parentRect = parent1.getBoundingClientRect();
  const relativeTop = parent1.scrollTop + childRect.top - parentRect.top;

   // Center the focused block inside the preview frame using the frame's ACTUAL
    // visible height (parent1.clientHeight). This stays centered for every aspect
    // ratio (16:9, 4:3, 1.85:1, 2.39:1) and every viewport width — no hard-coded
    // offset that only worked at one frame size. If a block is taller than the
    // frame, align its top instead of pushing its middle to center.
    const offset =
      childRect.height >= parent1.clientHeight
        ? 0
        : (parent1.clientHeight - childRect.height) / 2;

  // Window width based offset
  // const winHeight = detectwindowSize();
  // const scrollOffset = (winHeight < 1200) ? (winHeight < 1000 ? (winHeight < 900 ? (winHeight < 800 ? 180 : 260) : 260) : 260) : (260);

   parent1.scrollTo({
      behavior: "smooth",
      top: relativeTop - offset,
  });
 }
};

const endLines = (extra_lines_below, idx) => {
  if (extra_lines_below !== "") {
    return (
      <div id={idx + "endlines"}>
        {[...Array(extra_lines_below)].map((e, i) => (
          <br></br>
        ))}
      </div>
    );
  } else {
    return <div id={idx + "endlines"}></div>;
  }
};

export default function Preview({
  projectData,
  isFullscreen,
  exitFullscreen,
  isRenderExport,
  setIsRenderExport,
  isTitleSafe,
  aspectRatio_FrameSize,
}) {
  const dispatch = useDispatch();
  const previewRef = useRef(null);
// Skip the mount run so the ratio effect only reacts to actual ratio changes.
  const didMountRatio = useRef(false);

  const isOptionSelected = useSelector(
    (state) => state.commonReducer.isOptionSelected
  );
  // console.log(' Preview isOptionSelected === ', isOptionSelected);
  // Track fontStyle so we can correct scroll after font size changes
  const fontStyle = useSelector((state) => state.project.fontStyle);

  useEffect(() => {
    if (isRenderExport) {
      // window.location.reload();
      setIsRenderExport((prev) => !prev);
    }
  }, [isRenderExport]);

  const [size, setSize] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });
  const detectSize = () => {
    setSize({ winWidth: window.innerWidth, winHeight: window.innerHeight });
    detectwindowSize(size)
  };
  useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [size]);
const currentBlockIdx = projectData?.currentBlock?.idx;

  // When font style changes (size, weight, etc.), correct the scroll position
  // so the focused block stays in place instead of drifting down.
  // getBoundingClientRect ensures no scroll happens if already in position.
  useEffect(() => {
if (isOptionSelected === "font" && currentBlockIdx != null) {
      scrollTo("preview", "view_" + currentBlockIdx, "font", size);
    }
  }, [fontStyle]);

  // Same correction for layout option changes (margins, columns, block_inset, etc.)
  useEffect(() => {
    if (isOptionSelected === "layout" && currentBlockIdx != null) {
      scrollTo("preview", "view_" + currentBlockIdx, "font", size);
    }
  }, [projectData?.credits]);

   // Re-center the focused block when the aspect-ratio frame changes. The frame
  // resizes and CSS-transitions (~0.3s), so wait for it to settle, then center.
  useEffect(() => {
    if (!didMountRatio.current) {
      didMountRatio.current = true;
      return;
    }
    if (currentBlockIdx == null) return;
    const t = setTimeout(() => {
      scrollTo("preview", "view_" + currentBlockIdx);
    }, 350);
    return () => clearTimeout(t);
  }, [aspectRatio_FrameSize]);

  const onclick = (currentCreditBlockId, idx) => {
    dispatch(updateCurrentBlockState(currentCreditBlockId, idx));
    scrollTo("preview", "view_" + idx, isOptionSelected, size);
    scrollTo("content", "content" + idx, size);
  };

  useEffect(() => {
    try {
      scrollTo("preview", "view_" + currentBlockIdx, isOptionSelected, size);
      scrollTo("content", "content" + currentBlockIdx, size);
    } catch (error) {
      console.log(error);
    }
  }, [currentBlockIdx, isOptionSelected]);

  const getSafeSize = () => {
    const screenWidth = window.innerWidth;
  
    if (screenWidth < 1500) {
      return { w: 800, h: 450 };
    }
  
    if (screenWidth < 1600) {
      return { w: 860, h: 484 };
    }
  
    if (screenWidth < 1800) {
      return { w: 1130, h: 635.625 };
    }
    if (screenWidth < 2000) {
      return { w: 1250, h: 703.125 };
    }
    if (screenWidth < 2200) {
      return { w: 1400, h: 787.5 };
    }
    if (screenWidth < 2410) {
      return { w: 1570, h: 883.125 };
    }
    if (screenWidth < 2600) {
      return { w: 1675, h: 942.1875 };
    }
  
    // 1920 and above
    return { w: 1250, h: 703.125 };
  };
  
  const [safeSize, setSafeSize] = useState(getSafeSize);

  useEffect(() => {
    const getFrame = () =>
      document.querySelector("#preview-container .aspectRatioClassStyle");
  
    const measure = () => {
      const frame = getFrame();
  
      if (frame) {
        const r = frame.getBoundingClientRect();
  
        if (r.width) {
          setSafeSize({
            w: Math.round(r.width),
            h: Math.round(r.height),
          });
          return;
        }
      }
  
      // Fallback
      setSafeSize(getSafeSize());
    };
  
    measure();
  
    const raf = requestAnimationFrame(measure);
    const frame = getFrame();
    let ro;
  
    if (frame && window.ResizeObserver) {
      ro = new ResizeObserver(measure);
      ro.observe(frame);
    }
  
    window.addEventListener("resize", measure);
  
    return () => {
      cancelAnimationFrame(raf);
      ro?.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [
    isFullscreen,
    projectData?.resolution?.videoWidth,
    projectData?.resolution?.videoHeight,
  ]);

  const blockArr = projectData?.credits?.map(({ options, items, _id }, idx) => {
    return {
      block: (
        <div
          key={idx}
          className={
            "" +
            blockInsetClass[options.block_inset] +
            " viewBlock" +
            focusDiv(idx, currentBlockIdx)
          }
          block-title={options.block_name}
          onClick={(e) => {
            onclick(_id, idx);
          }}
          style={{ margin: `${options.margin_vertical}px 0` }}
        >
          {projectData?.settings && (
            <Block
              options={options}
              items={items}
              idx={idx}
              settings={projectData?.settings}
            />
          )}
          {endLines(options.extra_lines_below, idx)}
        </div>
      ),
      idx: idx,
      side_by_side: options.block_inset,
    };
  });

  let sideBySideBlocks = [];
  const { previewWidth, previewScale } = useSelector(
    (state) => state?.application
  );

  const previewBaseWidth = (() => {
    const screenWidth = window.innerWidth;
  
    if (screenWidth < 1500) return 800;
    if (screenWidth < 1600) return 860;
    if (screenWidth < 1800) return 1130;
    if (screenWidth < 2000) return 1250;
    if (screenWidth < 2200) return 1400;
    if (screenWidth < 2410) return 1570;
    if (screenWidth < 2600) return 1675;


  
    return 1920;
  })();

  const isExporting = previewScale !== 1;

const blockWrapperWidth = isFullscreen
  ? "100%"
  : isExporting
    ? `${previewWidth * previewScale}px`
    : `${previewBaseWidth}px`;

const contentWidth = isFullscreen
  ? "100%"
  : isExporting
    ? `${previewWidth}px`
    : `${previewBaseWidth}px`;


  return (
    <div className="previewCnt h-full">
      <div id="preview" className={"  scrollable"} ref={previewRef}>
        {blockArr?.map((data, idx) => {
          if (data.side_by_side === "sidebyside") {
            sideBySideBlocks.push(idx, idx + 1);
            return (
              <div
                id={"view_" + idx}
                className={"blockWrapper pr-prants"}
                style={{
                  // width: `${previewWidth * previewScale}px`
                  width: blockWrapperWidth,

                  // , backgroundColor: gobalBGcolor
                }}
              >
                <div className={"watermark_displaynone"}></div>
                <div className="flex flex-row gap-x-[30px]"
                  style={{
                    width: contentWidth,
                    transform: `scale(${previewScale})`,
                    transformOrigin: "top left",
                  }}
                >
                  <div className={"w-[50%] " + (idx === currentBlockIdx ? "focusDiv" : "")}>{data.block}</div>
                  <div className={ "w-[50%] " + (idx + 1 === currentBlockIdx ? "focusDiv" : "")}>{blockArr[idx + 1]?.block}</div>
                </div>
              </div>
            );
          } else {
            if (blockArr[idx - 1]?.side_by_side !== "sidebyside") {
              return (
                <div
                  id={"view_" + idx}
                  className={ "blockWrapper pr-prants " + (idx === currentBlockIdx ? "focusDiv hover:bg-[#0e0c1a]!importent" : "")}
                  style={{width: blockWrapperWidth}}
                >
                  <div className={"watermark_displaynone"}></div>
                  <div
                    style={{
                      width: contentWidth,
                      transform: `scale(${previewScale})`,
                      transformOrigin: "top left",
                    }}
                  >
                    {data.block}
                  </div>
                </div>
              );
            }
          }
        })}
      </div>
      {isTitleSafe && !isRenderExport && (
        <div
          className="cardTitleSafe"
          aria-hidden="true"
          data-html2canvas-ignore="true"
          style={{
            // Exact size of the measured card frame, so the guide hugs
            // its edges on every aspect ratio.
            width: safeSize.w,
            height: safeSize.h,
          }}
          
        >
           <div className="cardTitleSafeBox" />
          </div>
      )}
      
      {isFullscreen && <img src={scrollxLogo} alt="" className="fss2" />}

      {isFullscreen && (
        <button
          type="button"
          onClick={exitFullscreen}
          className={isFullscreen ? "fss" : "d-none"}
        >
          <span className="uppercase Syne700">EXIT</span>
        </button>
      )}
    </div>
  );
}
